import React from 'react'

const ProformaInvoice = () => {
  return (
    <div>ProformaInvoice</div>
  )
}

export default ProformaInvoice